/** 全屏加载 / 简单反馈占位，避免页面首屏空白。 */
export function FullPageLoading({ label = '正在加载…' }: { label?: string }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-slate-50">
      <span
        aria-hidden="true"
        className="h-8 w-8 animate-spin rounded-full border-2 border-brand-500 border-t-transparent"
      />
      <p className="text-sm text-slate-500">{label}</p>
    </div>
  );
}

export function InlineLoading({ label = '加载中…' }: { label?: string }) {
  return (
    <div className="flex items-center gap-2 py-6 text-sm text-slate-500" role="status">
      <span
        aria-hidden="true"
        className="h-4 w-4 animate-spin rounded-full border-2 border-slate-400 border-t-transparent"
      />
      {label}
    </div>
  );
}
